<template>
  <div class="frame-wrapper water-gate-show">
    <div class="filter-area-column">
      <div class="filter-area-left">
        <div class="change-button-area">
          <label class="switch-button-2">
              <input type="checkbox" v-model="switchValue" @change="onChange()" v-bind:disabled="selectedWaterGates.length > 0"/>
              <span>給水</span>
              <span>排水</span>
          </label>
        </div>
      </div>
      <div class="filter-area-left">
        <div class="filter-icon-paddy" @click="onClickArea"></div>
      </div>
    </div>
    <div
      v-if="isEditingWaterGate"
      class="center-frame-container"
    >
      <transition name="scale" @after-leave="isEditingWaterGate = false" appear>
        <div v-if="!isCenterFrameHidden" class="center-frame">
          <div class="title-area">
            <h3 v-if="isWaterSupplyGate">
              給水の記録
            </h3>
            <h3 v-else>
              排水の記録
            </h3>
            <div class="btn-close" @click="hideCenterFrame"></div>
          </div>

          <validation-observer ref="obs" v-slot="ObserverProps">
            <section class="section">
              <div class="container">
                <dl class="columns">
                  <!-- <dt>給水／排水</dt>
                  <dd>
                    <div>
                      <span v-if="isWaterSupplyGate">給水</span>
                      <span v-else>排水</span>
                    </div>
                  </dd> -->
                  <dt>開閉</dt>
                  <dd>
                    <div>
                      <input type="radio" id="close" name="flag_image" value="0" v-model="form.water_gate_status" /><label for="close">閉門</label>
                      <input type="radio" id="harlf" name="flag_image" value="1" v-model="form.water_gate_status" /><label for="harlf">半開</label>
                      <input type="radio" id="all" name="flag_image" value="2" v-model="form.water_gate_status" /><label for="all">全開</label>
                    </div>
                  </dd>
                  <dt>作業日時</dt>
                  <dd>
                    <ValidationProvider
                      rules="required"
                      immediate
                      v-slot="ProviderProps"
                    >
                      <input v-model="form.water_gate_time" type="datetime-local" />
                      <div class="validation-error">
                        {{ ProviderProps.errors[0] }}
                      </div>
                    </ValidationProvider>                    
                  </dd>
                  <dt>作業者</dt>
                  <dd>
                    <ValidationProvider
                      class="input-with-unit"
                      rules="required|max:100"
                      immediate
                      v-slot="ProviderProps"
                    >
                      <input
                        v-model="form.water_gate_worker"
                        type="text"
                      />
                      <div class="validation-error">
                        {{ ProviderProps.errors[0] }}
                      </div>
                    </ValidationProvider>
                    <div
                      v-if="
                        selectOptions.length > 1
                      "
                      class="input-with-user"
                    >
                      <template
                        v-for="(user, index) in selectOptions"
                      >
                        <label
                          class="label"
                          :key="'label-' + index"
                          @click="onAddUser(user)"
                        >
                          {{ user.user_name }}</label
                        >
                      </template>
                    </div>
                  </dd>
                </dl>
              </div>
            </section>

            <div id="button-area" v-if="isCenterFrameEdit">
              <div class="left-box" />
              <div class="center-box">
                <span
                  class="btn btn-submit"
                  :class="{ disable: ObserverProps.invalid }"
                  @click="onSubmit"
                  >登録</span
                >
                <span class="btn btn-cancel" @click="hideCenterFrame">キャンセル</span>
              </div>
              <div class="right-box">
              </div>
            </div>
          </validation-observer>
        </div>
      </transition>
    </div>
    <transition v-if="isShowGateFrame" name="fade" appear>
      <div class="gate-frame-container">
        <div class="gate-frame">
          <div class="gate-frame-header">
            <h4 v-if="isWaterSupplyGate">給水中</h4>
            <h4 v-else>排水中</h4>
            <div class="btn-close" @click="hideGateFrame"></div>
          </div>
          <div class="gate-frame-content">
            <div style="margin:10px">
              <table>
                <template v-if="openGateInfos.length > 0" >
                  <template v-for="(row, index) in openGateInfos">
                    <tr :key="index" @click="onClickOpenGate(index)">
                      <td>{{ row.paddy_field_name }}</td>
                      <td class="unit full-open" v-if="isWaterGateFull(row.water_gate_status)">{{ getWaterGateStatusName(row.water_gate_status) }}</td>
                      <td class="unit half-open" v-else-if="isWaterGateHalf(row.water_gate_status)">{{ getWaterGateStatusName(row.water_gate_status) }}</td>
                      <td class="unit" v-else>{{ getWaterGateStatusName(row.water_gate_status) }}</td>
                      <td class="value">{{ formatDatetime(row.water_gate_time) }}</td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                    <tr>
                      <td v-if="isWaterSupplyGate">給水中の水門はありません。</td>
                      <td v-else>排水中の水門はありません。</td>
                    </tr>
                </template>
              </table>
            </div>
          </div>
          <div class="gate-frame-footer"></div>
        </div>
      </div>
    </transition>
    <transition v-if="selectedWaterGates.length > 0" name="fade" appear>
      <div class="side-frame-container" v-if="!isMobileAny()">
        <div class="side-frame">
          <div id="side-frame-header">
            <div></div>
            <h4>選択済み（{{selectedWaterGates.length}}）</h4>
            <div class="btn-close" @click="clearSelectedWaterGates"></div>
          </div>
          <div class="side-frame-content">
            <div
              v-for="waterGate in selectedWaterGates"
              :key="waterGate.paddy_field_id"
              class="side-frame-row"
            >
              <div>
                <span :class="getPinIcon(waterGate)"></span>
                <p>{{ waterGate.name }}</p>
              </div>
            </div>
          </div>

          <div id="side-frame-footer">
            <span
              class="btn-submit"
              :class="{ disable: selectedWaterGates.length === 0 }"
              @click="onFixPaddyFields"
              >記録する</span
            >
          </div>
        </div>
      </div>
      <div v-else class="side-frame-container">
        <div id="select-box" class="active">
          {{ selectedPaddyFieldName }}
        </div>
        <div id="next-btn" class="active" @click="onFixPaddyFields">
          <span>記録する</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/mixins/loader";
import isMobile from "@/mixins/ismobile";
import GoogleMaps from "@/mixins/googlemaps";
import Dialog from "@/mixins/dialog";
import { mapActions, mapGetters } from "vuex";

const CENTER_FRAME_STATUS = { HIDDEN: 0, REFERENCE: 1, EDIT: 2 };
const WATER_GATE_STATUS = { CLOSED: "0", HALF: "1", FULL: "2" };
const WATER_GATE_ICON = {
  CLOSED: "ricelog_pinicon_043",
  HALF: "ricelog_pinicon_033",
  FULL: "ricelog_pinicon_073",
};
const WATER_GATE_ICON_SELECTED = {
  CLOSED: "ricelog_pinicon_041",
  HALF: "ricelog_pinicon_031",
  FULL: "ricelog_pinicon_071",
};

export default {
  mixins: [Loader, isMobile, GoogleMaps, Dialog],

  data() {
    return {
      markers: [],
      isEditingWaterGate: false,
      centerFrameStatus: CENTER_FRAME_STATUS.HIDDEN,
      form: {
        water_gate_status: null,
        water_gate_time: null,
        water_gate_worker: null,
      },
      selectOptions: [],
      isShowGateFrame: false,
      openGateInfos: [],
      switchValue: false,
      // 選択した田圃
      selectedWaterGates: [],
      // 直近で選択状態にした田圃の名前
      selectedPaddyFieldName: null,
    };
  },

  computed: {
    isCenterFrameHidden() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.HIDDEN;
    },

    isCenterFrameEdit() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.EDIT;
    },
    isWaterSupplyGate() {
      return !this.switchValue;
    },
    isWaterOutGate() {
      return this.switchValue;
    },

  },
  filters: {
    addComma(val) {
      if (!val) {
        return val;
      }
      // 整数部のみカンマをつける
      const vals = val.toString().split(".");
      let ret = vals[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (vals.length > 1) {
        ret += "." + vals[1];
      }
      return ret;
    },
  },

  async mounted() {
    this.loading(async () => {
      this.$emit("showMap");
      try {
        // マーカー初期表示
        await this.loadMarkers();
        this.setSelectListener();

        // ユーザリスト
        await this.listUsers();

      } catch (error) {
        console.log(error);
        throw error;
      }
    });
  },

  destroyed() {
    this.clearMarkers();
  },

  methods: {
    ...mapActions([
      "retrieveWaterGates",
      "showUsers",
      "insertWaterSupplyGate",
      "insertWaterOutGate",
      "insertWaterSupplyGates",
      "insertWaterOutGates",
    ]),
    ...mapGetters(["getWaterGates", "getWaterSupplyGates", "getWaterOutGates", "getDisplayName"]),

    hideCenterFrame() {
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
      // フォームデータ初期化
      Object.keys(this.form).forEach((key) => {
        this.form[key] = null;
      });
    },

    async loadMarkers() {
      // 最新の田圃の位置情報を取得
      await this.retrieveWaterGates();
      // 現在マップに残っているマーカーをクリア
      this.clearMarkers();
      // マーカー表示
      this.putMarkers();
    },

    putMarkers() {
      const { Marker } = this.google.maps;
      let waterGates = this.getWaterGates();
      
      waterGates.forEach((waterGate) => {
        const lat = parseFloat(waterGate.map_pos.split(",")[0]);
        const lng = parseFloat(waterGate.map_pos.split(",")[1]);

        const marker = new Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
        });
        marker.setIcon(this.buildMarkerIconProps(waterGate, false));
        marker.set("waterGate", waterGate);
        this.setInfoWindow(marker, waterGate);
        this.markers.push(marker);
      });
    },

    setInfoWindow(marker, waterGate) {
      var message = [];
      if (waterGate.name) {
        message.push(waterGate.name);
      }
      var infowin = new this.google.maps.InfoWindow({
        content: message.join("<br>"),
      });

      // mouseoverイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseover", function () {
        infowin.open(marker.getMap(), marker);
      });

      // mouseoutイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseout", function () {
        infowin.close();
      });
    },

    getPinIcon(waterGate) {
      let iconName = WATER_GATE_ICON_SELECTED.CLOSED;
      let gateStatus;
      if (this.switchValue) {
        // 排水マップ
        gateStatus = waterGate.water_out_gate_status;
      }
      else {
        // 給水マップ
        gateStatus = waterGate.water_supply_gate_status;
      }
      if (gateStatus) {
        if (gateStatus === WATER_GATE_STATUS.HALF) {
          iconName = WATER_GATE_ICON_SELECTED.HALF;
        }
        else if (gateStatus === WATER_GATE_STATUS.FULL) {
          iconName = WATER_GATE_ICON_SELECTED.FULL;
        }
      }

      return iconName;
    },

    setSelectListener() {
      this.markers.forEach((marker) => {
        marker.addListener("click", () => {
          this.loading(async () => {

            let waterGate = marker.get("waterGate");

            // 選択済みのマーカーか
            let selected = this.selectedWaterGates.find((e) => {
              return e === waterGate;
            });

            if (selected) {
              // 選択リストから削除
              this.selectedWaterGates = this.selectedWaterGates.filter(
                (e) => e !== waterGate
              );
              // 選択時の田圃名をクリアする
              this.selectedPaddyFieldName = null;
            } else {
              // 選択リストに追加
              this.selectedWaterGates.push(waterGate);
              // 選択時の田圃名を設定する
              this.selectedPaddyFieldName = waterGate.name;
            }

            marker.setIcon(this.buildMarkerIconProps(waterGate, !selected));

          });
        });
      });
    },

    buildMarkerIconProps(waterGate, selected) {
      let iconName = WATER_GATE_ICON.CLOSED;
      if (selected) {
        iconName = WATER_GATE_ICON_SELECTED.CLOSED;
      }
      let gateStatus;
      if (this.switchValue) {
        // 排水マップ
        gateStatus = waterGate.water_out_gate_status;
      }
      else {
        // 給水マップ
        gateStatus = waterGate.water_supply_gate_status;
      }
      if (gateStatus) {
        if (gateStatus === WATER_GATE_STATUS.HALF) {
          if (selected) {
            iconName = WATER_GATE_ICON_SELECTED.HALF;
          } else {
            iconName = WATER_GATE_ICON.HALF;
          }
        }
        else if (gateStatus === WATER_GATE_STATUS.FULL) {
          if (selected) {
            iconName = WATER_GATE_ICON_SELECTED.FULL;
          } else {
            iconName = WATER_GATE_ICON.FULL;
          }
        }
      }

      // アイコンファイル名の組み立て
      let iconProps = { url: this.buildMarkerIcon(iconName) };
      iconProps = Object.assign(iconProps, {
        scaledSize: { width: 24, height: 42 },
        anchor: { x: 12, y: 42 },
      });
      return iconProps;
    },

    buildMarkerIcon(iconName) {
      return require("@/assets/pin/" + iconName + ".png");
    },

    clearSelectedWaterGates() {
      this.selectedWaterGates.forEach((item) => {
        // markerオブジェクト取得
        const nowSelected = this.markers.find(
          (m) => m.get("waterGate") === item
        );

        // マーカーの選択状況を反転
        nowSelected.setIcon(this.buildMarkerIconProps(item, false));
      });
      // 選択済みリストクリア
      this.selectedWaterGates = [];
    },

    clearMarkers() {
      this.markers.forEach((e) => {
        // Mapとの紐付けを解除しイベントリスナーを削除
        e.setMap(null);
        this.google.maps.event.clearInstanceListeners(e);
      });
      this.markers = [];
    },

    onFixPaddyFields() {
      if (this.selectedWaterGates.length === 0) {
        return;
      }
      this.onEdit();
    },

    onEdit() {
      this.centerFrameStatus = CENTER_FRAME_STATUS.EDIT;

      this.form.water_gate_status = WATER_GATE_STATUS.CLOSED;
      this.form.water_gate_time = this.formatDatetime(new Date(), "YYYY-MM-DDTHH:mm");
      this.form.water_gate_worker = this.getDisplayName();

      this.isEditingWaterGate = true;
    },


    async onSubmit() {
      this.loading(async () => {
        try {
          const params = {
            paddy_field_ids: this.selectedWaterGates.map( waterGate => waterGate.paddy_field_id ),
          };

          Object.assign(params, this.form);

          // 更新
          if (this.switchValue) {
            await this.insertWaterOutGates(params);
          }
          else {
            await this.insertWaterSupplyGates(params);
          }

          // 内部データクリア
          this.hideCenterFrame();

          // マーカーをリロード
          this.clearSelectedWaterGates();
          await this.loadMarkers();
          this.setSelectListener();
        } catch (error) {
          alert("通信エラー");
          console.log(error);
          throw error;
        }
      });
    },

    async listUsers() {
      this.selectOptions = [];
      try {
        const Users = await this.showUsers();

        // ユーザデータの整形
        Users.forEach((user) => {
          let _tmp = {};
          user.Attributes.forEach((attr) => {
            if (attr.Name === "custom:display_name") {
              _tmp.user_name = attr.Value;
            } else if (attr.Name === "custom:user_id") {
              _tmp.user_id = attr.Value;
            }
          });
          this.selectOptions.push(_tmp);
        });
      } catch (e) {
        console.error(e);
      }
    },
    hideGateFrame() {
      this.isShowGateFrame = false;
    },

    async onClickArea() {
      this.openGateInfos = [];
      if (this.isShowGateFrame) {
        this.isShowGateFrame = false;
      } else {
        this.isShowGateFrame = true;
        if (this.switchValue) {
          this.openGateInfos = this.getWaterOutGates();
        }
        else {
          this.openGateInfos = this.getWaterSupplyGates();
        }
      }
    },

    onClickOpenGate(index) {
      const lat = parseFloat(this.openGateInfos[index].map_pos.split(",")[0]);
      const lng = parseFloat(this.openGateInfos[index].map_pos.split(",")[1]);
      this.map.panTo(new this.google.maps.LatLng(lat,lng));
      this.map.setZoom(17);
    },

    async onChange(){
      this.loading(async () => {
        try {
          // 内部データクリア
          this.hideCenterFrame();
          this.isShowGateFrame = false;
          this.openGateInfos = [];

          // マーカーをリロード
          await this.loadMarkers();
          this.setSelectListener();
        } catch (error) {
          alert("通信エラー");
          console.log(error);
          throw error;
        }
      });
    },
    onAddUser(user) {
      let _name = "";
      if (this.form.water_gate_worker) {
        _name = this.form.water_gate_worker + "、";
      }
      this.form.water_gate_worker = _name + user.user_name;
    },

    formatDatetime(src, format = "YYYY/MM/DD HH:mm") {
      if (!src) {
        return "";
      }
      let dest = format;
      const date = new Date(src);
      dest = dest.replace(/YYYY/, date.getFullYear());
      dest = dest.replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2));
      dest = dest.replace(/DD/, ("0" + date.getDate()).slice(-2));
      dest = dest.replace(/HH/, ("0" + date.getHours()).slice(-2));
      dest = dest.replace(/mm/, ("0" + date.getMinutes()).slice(-2));
      dest = dest.replace(/ss/, ("0" + date.getSeconds()).slice(-2));
      dest = dest.replace(/SSS/, ("0" + date.getMilliseconds()).slice(-3));
      return dest;
    },    
    isWaterGateFull(status) {
      return status === WATER_GATE_STATUS.FULL;
    },
    isWaterGateHalf(status) {
      return status === WATER_GATE_STATUS.HALF;
    },
    getWaterGateStatusName(status) {
      if (this.isWaterGateFull(status)) {
        return "全開";
      }
      else if (this.isWaterGateHalf(status)) {
        return "半開";
      }
      else {
        return "閉門";
      }
    },
  },
};
</script>

<style lang="scss">
$side-frame-width: 350px;

.water-gate-show {
  &.frame-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .col1 {
    display: inline-block;
    text-align: center;
    color: var(--col1);
    border: 1px solid var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col1-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col2 {
    display: inline-block;
    text-align: center;
    color: var(--col2);
    border: 1px solid var(--col2);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col2-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col2);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col3 {
    display: inline-block;
    text-align: center;
    color: var(--col3);
    border: 1px solid var(--col3);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col3-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col3);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col4 {
    display: inline-block;
    text-align: center;
    color: var(--col4);
    border: 1px solid var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col4-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .side-frame-container {
    position: absolute;
    top: 30px;
    right: 30px;
    width: $side-frame-width;
    min-width: 270px;
    //   max-width: 450px;
    min-height: 100px;
    //   padding: 30px 30px 30px 0;
    .mobile & {
      min-width: unset;
      min-height: unset;
    }

    .side-frame {
      // width: 100%;
      // min-width: 270px;
      // max-width: 450px;
      // min-height: 100px;
      padding: 0px;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    #side-frame-header {
      // display: flex;
      display: grid;
      grid-template-columns: 1fr 5fr 1fr;
      align-items: center;
      width: 100%;
      height: 50px;
      padding: 10px;
      background: #ddd;
      border-radius: 20px 20px 0 0;
      box-sizing: border-box;
    }

    #side-frame-footer {
      width: 100%;
      padding: 5px;
      border-radius: 0 0 20px 20px;
      background: #ddd;
    }

    .side-frame h4 {
      font-size: 18px;
      text-align: center;
      font-weight: normal;
      margin: 0px auto 0;
      // padding: 0 0 0 2em;
    }
    .side-frame h4::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_list.svg") no-repeat center center;
      margin: 0 10px 0 0;
    }

    .side-frame-content {
      // 170px＝サイドフレームの上下padding＋ヘッダ＋フッタ
      max-height: calc(100vh - 170px);
      box-sizing: border-box;
      overflow: scroll;

      .side-frame-content-header {
        overflow: auto;
        width: 100%;
        position: relative;
        font-size: 15px;

        dl.columns {
          width: 100%;
          display: grid;
          grid-template-columns: 180px 1fr;
          align-items: top;
          grid-gap: 0px 0px;
          margin: 0;
          padding: 0;
          font-size: 16px;
          color: #333;

          .mobile & {
            grid-template-columns: 1fr 1.5fr;
          }
        }

        .columns dt {
          display: block;
          text-align: right;
          width: 100%;
          margin: 0;
          padding: 16px;
        }

        .columns dd {
          display: block;
          width: 100%;
          border-left: solid 1px #ddd;
          margin: 0;
          padding: 16px;

          .input-with-unit {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .unit {
              margin-left: 1rem;
              word-break: keep-all;
            }
            input {
              width: auto;
              flex-grow: 2;
            }
          }
        }

        .header-title {
          text-align: center;
          font-weight: bold;
        }
        .header-title2 {
          text-align: center;
        }

        table {
          margin: auto;

          .item-title {
            text-align: right;
            padding-right: 10px;
            min-width: 100px;
          }

          .item-name {
            max-width: 150px;
          }
          .item-count {
            text-align: right;
            min-width: 40px;
          }
        }
      }
    }

    .side-frame-row {
      width: 100%;
      margin: 0 auto 0;
      /* min-height: 100px; */
      // border-bottom: solid 1px #ddd;
      border-top: solid 1px #ddd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
    }

    .side-frame-row div {
      display: flex;
      align-items: center;
    }
    .side-frame-row p {
      font-size: 15px;
      display: block;
    }
    .side-frame-row span {
      min-width: 25px;
      width: 25px;
      height: 45px;
      display: block;
      margin: 0 10px 0 0;
    }

    .side-frame-row.view-header {
      cursor: pointer;
    }

    p.view-date {
      font-size: 18px;
    }

    .side-frame-content ul {
      font-size: 14px;
      color: #555;
      background: #f9f9f9;
      margin: 0;
      padding: 20px 20px 20px 40px;
    }

    .side-frame-row .mark {
      font-size: 12px;
      padding: 3px 9px;
    }

    .btn-submit {
      display: block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 100px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
    }

    .btn-close {
      cursor: pointer;
      width: 26px;
      height: 26px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .ricelog_pinicon_010 {
    background: url("~@/assets/pin/ricelog_pinicon_010.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_011 {
    background: url("~@/assets/pin/ricelog_pinicon_011.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_012 {
    background: url("~@/assets/pin/ricelog_pinicon_012.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_013 {
    background: url("~@/assets/pin/ricelog_pinicon_013.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_020 {
    background: url("~@/assets/pin/ricelog_pinicon_020.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_030 {
    background: url("~@/assets/pin/ricelog_pinicon_030.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_031 {
    background: url("~@/assets/pin/ricelog_pinicon_031.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_032 {
    background: url("~@/assets/pin/ricelog_pinicon_032.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_033 {
    background: url("~@/assets/pin/ricelog_pinicon_033.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_040 {
    background: url("~@/assets/pin/ricelog_pinicon_040.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_041 {
    background: url("~@/assets/pin/ricelog_pinicon_041.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_042 {
    background: url("~@/assets/pin/ricelog_pinicon_042.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_043 {
    background: url("~@/assets/pin/ricelog_pinicon_043.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_050 {
    background: url("~@/assets/pin/ricelog_pinicon_050.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_060 {
    background: url("~@/assets/pin/ricelog_pinicon_060.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_070 {
    background: url("~@/assets/pin/ricelog_pinicon_070.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_071 {
    background: url("~@/assets/pin/ricelog_pinicon_073.png") no-repeat center
      center;
    background-size: 25px 45px;
  }
  .ricelog_pinicon_073 {
    background: url("~@/assets/pin/ricelog_pinicon_073.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_080 {
    background: url("~@/assets/pin/ricelog_pinicon_080.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_090 {
    background: url("~@/assets/pin/ricelog_pinicon_090.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_100 {
    background: url("~@/assets/pin/ricelog_pinicon_100.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  img.pinicon {
    width: 24px;
    height: 42px;
  }

  .image-radio-button {
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    margin: 2px;
    float: left;
  }
  .image-radio-button:hover {
    background: #eee;
  }
  .image-radio-button img {
    height: 42px;
    width: 24px;
  }
  .image-radio-button label {
    cursor: pointer;
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      position: absolute;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;
    }

    //   &.active {
    //     display: flex;
    //     /* animation: scaleAnimIn 0.3s ease-out; */
    //   }

    .title-area {
      width: 100%;
      min-height: 80px;
      padding: 0;
      padding-bottom: 10px;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
      min-width: 25px;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    #edit-area {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    #edit-area span {
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }

    #edit-area span.active {
      border-bottom: solid 4px var(--purple);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    #edit-area span.disabled {
      border-bottom: solid 4px var(--purple);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }

    #edit-area span::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 15px;
    }

    #button-area {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      .right-box {
        right: 0;
        bottom: 0;
        width: 70px;
      }
      .center-box {
        display: inline;
        text-align: center;
        width: calc(100% - 140px);
      }
      .left-box {
        left: 0;
        bottom: 0;
        width: 70px;
      }

      .btn {
        display: inline-block;
        background: white;
        font-size: 14px;
        text-align: center;
        width: 130px;
        height: 30px;
        border-radius: 15px;
        color: var(--purple);
        padding: 6px 20px;
        margin: 10px auto 10px;
        cursor: pointer;
        &.disable {
          opacity: 0.5;
          cursor: inherit;
          pointer-events: none;
        }
        &.btn-submit {
          background: var(--purple);
          color: #fff;
          margin-left: 3px;
          margin-right: 3px;
        }
        &.btn-cancel {
          background: var(--purple-tertiary);
          color: #000;
          margin-left: 3px;
          margin-right: 3px;
        }
      }

      .text {
        right: 0;
        bottom: 0;
        display: block;
        font-size: 14px;
        padding: 3px 0px;
        margin: 10px 0;
        text-align: center;
        color: var(--purple);
        border-bottom: solid 4px transparent;
        opacity: 0.5;
        pointer-events: none;
      }
      .text.active {
        border-bottom: solid 4px var(--purple-secondary);
        opacity: 1;
        cursor: pointer;
        pointer-events: inherit;
      }
      .text::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
        background-size: 20px 20px;
        padding: 0 0 0 5px;
      }
    }

    .section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        dl.columns {
          width: 100%;
          display: grid;
          grid-template-columns: 170px 1fr;
          align-items: top;
          grid-gap: 0px 0px;
          margin: 0;
          padding: 0;
          font-size: 16px;
          color: #333;
        }

        .columns dt {
          display: block;
          text-align: right;
          width: 100%;
          margin: 0;
          padding: 16px;
        }

        .columns dd {
          display: block;
          width: 100%;
          border-left: solid 1px #ddd;
          margin: 0;
          padding: 16px;

          .input-with-unit {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .unit {
              margin-left: 1rem;
              word-break: keep-all;
            }
            input {
              width: auto;
              flex-grow: 2;
            }
          }
          .input-with-user {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // margin: 0 0 10px 0;

            .label {
              padding: 0 0 0 5px;
              cursor: pointer;
            }
            .label::before {
              white-space: pre;
              content: "    ";
              background: url("~@/assets/icons/ic_add_circle.svg") no-repeat
                center center;
              background-size: 20px 20px;
              padding: 0 0 0 15px;
            }
          }

          span.textarea {
            white-space: pre-line;
          }
        }
        // .columns dt:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }
        // .columns dd:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }

        /* フォーム */

        input[type="text"],
        input[type="date"],
        input[type="time"],
        input[type="datetime-local"],
        input[type="number"] {
          width: 100%;
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 16px;
          font-size: 16px;
          outline: none;
        }

        input[type="text"]:focus,
        input[type="date"]:focus,
        input[type="time"]:focus,
        input[type="datetime-local"]:focus,
        input[type="number"]:focus {
          background: var(--purple-tertiary);
        }

        select {
          width: 100%;
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 38px 0 16px;
          font-size: 16px;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center;
          background-size: 25px 25px;
        }

        select:focus {
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center var(--purple-tertiary);
          background-size: 25px 25px;
        }

        textarea {
          font-size: 16px;
          width: 100%;
          min-height: 200px;
          white-space: pre-wrap;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border: solid 1px var(--purple);
          padding: 10px;
          border-radius: 10px 10px 0 10px;
          font-family: inherit;
        }

        textarea:focus {
          background: var(--purple-tertiary);
        }

        input[type="radio"] {
          display: none;
        }
        input[type="radio"] + label {
          padding: 0 20px 0 0;
        }
        input[type="radio"]:disabled + label {
          color: #aaa;
        }

        input[type="radio"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
            left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="radio"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
        input[type="radio"]:disabled + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
            center left;
          background-size: 24px 24px;
          display: inline-block;
        }

        input[type="checkbox"] {
          display: none;
        }
        input[type="checkbox"] + label {
          padding: 0 20px 0 0;
        }

        input[type="checkbox"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat
            center left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="checkbox"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
      }
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .scale-enter,
  .scale-leave-to {
    transform: scale(0.5);
    opacity: 0;
  }
  .scale-enter-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-out;
  }
  .scale-leave-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-in;
  }
  .filter-area-column {
    display: flex;
    position: absolute;
    flex-flow: column;
  }
  .filter-area-left {
    display: flex;
    // position: absolute;

    .filter-icon-paddy {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: white url("~@/assets/icons/ic_filter_water.svg") no-repeat
        center center;
      // margin: 15px;
      margin-left: 15px;
      margin-right: 15px;
      cursor: pointer;
    }
  }
  // .filter-area-right {
  //   display: flex;
  //   position: absolute;
  //   top: 0;
  //   right: 0;

  //   .filter-icon-paddy {
  //     display: block;
  //     width: 40px;
  //     height: 40px;
  //     border-radius: 50%;
  //     background: white url("~@/assets/icons/ic_filter_paddy.svg") no-repeat
  //       center center;
  //     margin: 15px;
  //     cursor: pointer;
  //   }
  // }
  .gate-frame-container {
    position: absolute;
    display: flex;
    margin: 20px;
    top: 115px;
    z-index: 1;
    max-width: 350px;
    min-width: 270px;
    min-height: 100px;

    .gate-frame {
      width: 100%;
      padding: 0px;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    .gate-frame-header {
      width: 100%;
      height: 60px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 50px;
      align-items: center;
      // border-bottom: solid 1px #ddd;
      border-radius: 20px 20px 0 0;
      background: #ddd;
    }

    .gate-frame-header h4 {
      font-size: 20px;
      font-weight: bold;
      margin: 0 auto 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .btn-close {
      cursor: pointer;
      width: 24px;
      height: 24px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    .gate-frame-content {
      // margin: 10px 20px;
      font-size: 14px;
      overflow: scroll;
      max-height: calc(100vh - 280px);

      table {
        width: 100%;

        tr {
          line-height: 1.75rem;
          &:nth-of-type(n + 2) {
            border-top: solid 1px darkgray;
          }
        }
        td {
          padding-right: 5px;
        }
        // .label {
        // text-align: right;
        // max-width: 50%;
        // }
        .unit {
          text-align: right;
          white-space: nowrap;
          padding: 0 0 0 10px;
        }
        .value {
          // min-width: 6rem;
          white-space: nowrap;
          text-align: right;
          padding: 0 0 0 10px;
        }
        .full-open {
          color:var(--col3);
        }
        .half-open {
          color:var(--col5);
        }

      }
      ul {
        list-style: none;
        padding: 0;
      }
    }

    .gate-frame-footer {
      width: 100%;
      height: 40px;
      background: #ddd;
      border-radius: 0 0 20px 20px;
    }
  }
  .change-button-area {
      margin: 15px;
  }
  .switch-button {
      display: flex;
      align-items: center;
      position: relative;
      width: 200px;
      height: 50px;
      border-radius: 50px;
      box-sizing: content-box;
      // background-color: #ff8d8d33;
      cursor: pointer;
      // transition: background-color .4s;
      background-color: white;
  }

  .switch-button:has(:checked) {
      // background-color: #75bbff33;
      background-color: white;
  }

  .switch-button::before {
      position: absolute;
      left: 5px;
      width: 100px;
      height: 42px;
      border-radius: 50px;
      background-color: var(--col3);
      content: '';
      transition: left .4s;
  }

  .switch-button:has(:checked)::before {
      left: 95px;
      background-color: #75bbff;
  }

  .switch-button::after {
      position: absolute;
      left: 55px;
      transform: translateX(-50%);
      color: #fff;
      font-weight: 600;
      font-size: .9em;
      content: '給水';
      transition: left .4s;
  }

  .switch-button:has(:checked)::after {
      left: 146px;
      content: '排水';
  }

  .switch-button input {
      display: none;
  }

  .switch-button-2 {
      display: flex;
      align-items: center;
      position: relative;
      width: 200px;
      height: 50px;
      border-radius: 10px;
      box-sizing: content-box;
      // background-color: #ff8d8d33;
      cursor: pointer;
      // transition: background-color .4s;
      background-color: white;

      span {
        width:100px;
        text-align:center;
        color:#999999
      }
  }

  .switch-button-2:has(:checked) {
      // background-color: #75bbff33;
      background-color: white;
  }

  .switch-button-2::before {
      position: absolute;
      left: 5px;
      width: 100px;
      height: 42px;
      border-radius: 8px;
      background-color: #295F98;
      content: '';
      transition: left .4s;
  }

  .switch-button-2:has(:checked)::before {
      left: 95px;
      background-color: #CDC2A5;
  }

  .switch-button-2::after {
      position: absolute;
      left: 55px;
      transform: translateX(-50%);
      color: #fff;
      font-weight: 600;
      font-size: .9em;
      content: '給水';
      transition: left .4s;
  }

  .switch-button-2:has(:checked)::after {
      left: 146px;
      content: '排水';
  }

  .switch-button-2 input {
      display: none;
  }
// .btn {
// 	display: flex;
// 	align-items: center;
// 	justify-content: center;
// 	width: 126px;
// 	height: 42px;
// 	background: #CDC2A5;
// 	color: #fff;
// 	border-radius:50px;
// 	// font-size: 1.0rem;
// 	cursor: pointer;
// }
// .btn:before {
// 	content: '排水マップ';
// }
// .checkbox {
// 	display: none;
// }
/*以下を追記*/
.checkbox:checked+.btn {
	background: #295F98;
}
.checkbox:checked+.btn:before {
	content: '給水マップ';
}

/* アニメーション */

  @keyframes scaleAnimIn {
    0% {
      display: flex;
      transform: scale(0.5);
    }
    100% {
      display: flex;
      transform: scale(1);
    }
  }

  @keyframes fadeAnimIn {
    0% {
      display: grid;
      opacity: 0;
    }
    100% {
      display: grid;
      opacity: 1;
    }
  }
}
</style>
